module.exports = __webpack_public_path__ + "images/nps/twitter.3f9b6f94a110473bc5b8.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/nps/twitter.svg
// module id = ox3T
// module chunks = 12